<template lang="pug">
    v-app-bar(absolute="" color="transparent" flat="" height="85")
      v-container.px-0.text-right.d-flex.align-center
        v-toolbar-title.font-weight-light.hidden-xs-only(v-text="title")
        v-spacer
        v-btn(v-for="(item, i) in items" :key="i" :to="item.to" min-height="48" min-width="40" text="")
          v-icon(:left="$vuetify.breakpoint.mdAndUp" size="20" v-text="item.icon")
          span.hidden-sm-and-down(v-text="item.text")

</template>

<script>
  export default {
    name: 'PagesCoreAppBar',

    data: () => ({
      items: [
        // {
        //   icon: 'mdi-view-dashboard',
        //   text: 'Dashboard',
        //   to: '/',
        // },
        {
          icon: 'mdi-home',
          text: 'Home',
          to: '/',
        },
        // {
        //   icon: 'mdi-currency-usd',
        //   text: 'Planes',
        //   to: '/pages/pricing',
        // },
        {
          icon: 'mdi-account-multiple-plus',
          text: 'Registrate',
          to: '/pages/register',
        },
        {
          icon: 'mdi-fingerprint',
          text: 'Ingresar',
          to: '/pages/login',
        },
        // {
        //   icon: 'mdi-lock-open-outline',
        //   text: 'Lock',
        //   to: '/pages/lock',
        // },
      ],
      titles: {
        '/': 'Buscar',
        '/pages/lock': '',
        '/pages/login': 'Ingresar',
        '/pages/pricing': 'Planes',
        '/pages/register': 'Registro',
      },
    }),

    computed: {
      title () {
        return this.titles[this.$route.path]
      },
    },

    mounted () {
      this.fetch()
    },

    methods: {
      fetch () {
        const vm = this
        vm.$store.dispatch('cms/loadItems', 'static').then(() => {
          vm.$store.commit('cms/setLoading', false)
        })
      },
    },
  }
</script>
